import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import TopicBasicInfoComponent from './topic-basic-info.component';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';

export const TopicComponent = ({
  parentTopicsList, FileType, handleInnerFormChange,id, EntityType, Moduleslist, Chapterslist, onFormItemChange, selectedTopics, back, handleFormSubmit, ModuleId
}: any) => {

  const handleInnerMediaFormChange: any = ({ field, value }: any) => {
    onFormItemChange({
      value: value.MediaFiles,
      field: 'MediaFiles',
      idx: '', //not used
    });
  };

  const tabItems = [
    {
      id: 1,
      title: 'Topic Basic Information',
      component: <TopicBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedTopics={selectedTopics}
        parentTopicsList={parentTopicsList}
        ModuleId={ModuleId}
        EntityType={EntityType}
        Moduleslist={Moduleslist}
        Chapterslist={Chapterslist}
        FileType={FileType}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Media',
      component:
        <UploadMedia
          handleInnerFormChange={handleInnerMediaFormChange}
          mediaFilesList={selectedTopics?.MediaMappings?.MediaFiles}
          ownerTypeId={1007}
          ownerId={id}
          folderName={'topics'}
        />,
      isVisible: true,
    },
  ]

  return (
    <>
      <TabContainer tabItems={tabItems} />
      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </>
  )
}

export default TopicComponent;
